import React from "react";
import CurrencyUtils from "../../utils/currencyUtils";
import {PropTypes} from "prop-types";
import {connect} from "react-redux";
import {convertDateTime} from "../../utils/dateTimeUtils";
import {withTheme} from "styled-components";

class Invoices extends React.Component {

    render() {
        let invoices = this.props.invoices;
        if (invoices === null) {
            return false;
        }
        const useGuestCurrencyCharges = invoices[0]?.guestCurrencyCharges !== undefined && invoices[0]?.guestCurrencyCharges !== null;
        let total = 0;
        //Charges coming as null would be NaN and break count
        invoices.forEach((invoice) => {
            total += parseFloat(
                useGuestCurrencyCharges ? invoice.guestCurrencyCharges
                    : invoice.chargesWithDiscounts ? invoice.chargesWithDiscounts
                        : invoice.charges
            );
        });
        total = Math.round(total * 100) / 100;

        const showDepartment = !!invoices?.[0]?.department;

        const currency = this.props.invoices?.[0]?.currencySymbol ? this.props.invoices[0].currencySymbol : this.props.currency

        return (
            <div>
                <h4>{this.context.t("total_charges")} { CurrencyUtils.formatCurrency(currency, total ) }</h4>
                <table className="animated fadeIn">
                    <thead>
                    <tr>
                        <th>{this.context.t("date")}</th>
                        {showDepartment && <th>{this.context.t("department")}</th>}
                        <th>{this.context.t("description")}</th>
                        <th>{this.context.t("charges")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    { invoices.length === 0 &&
                        <tr>
                            <td colSpan="4">
                                {this.context.t("no_charges")}
                            </td>
                        </tr>
                    }
                    {
                        invoices.map((invoice, i) =>
                            <React.Fragment key={i}>
                                <tr>
                                    <td>
                                        { convertDateTime(invoice.chargeDate, "DD/MM/YYYY HH:mm", "default", "", this.props.theme.dateLocale === "en-US" && "en-US") }
                                    </td>
                                    {showDepartment && <td>{invoice.department}</td>}
                                    <td>{invoice.description}</td>
                                    <td>{CurrencyUtils.formatCurrency(currency, useGuestCurrencyCharges ? invoice.guestCurrencyCharges : invoice.charges)}</td>
                                </tr>

                                {/* hotelfriend clients will have discounts field coming back as string, other clients as null */}
                                {invoice.discounts && invoice.discounts !== "0.00" &&
                                <tr>
                                    <td></td>
                                    {showDepartment && <td></td>}
                                    <td>{this.context.t("discount")}</td>
                                    <td>{CurrencyUtils.formatCurrency(this.props.currency, invoice.discounts)}</td>
                                </tr>
                                }
                            </React.Fragment>
                        )
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

Invoices.contextTypes = {
    t: PropTypes.func.isRequired
};
const mapStateToProps = (state, ownProps) => {
    return {
        invoices: ownProps.invoices,
        currency: state.configuration.hubSettings.currency,
        lang: state.i18nState.lang
    };
};
export default connect(mapStateToProps)(withTheme(Invoices));


